import axios from "axios";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { UnauthorizedError } from "../Translation";

const userToken = uuidv4();
sessionStorage.setItem("userToken", userToken);
const token = sessionStorage.getItem("userToken") || uuidv4();

const searchParams = new URLSearchParams(document.location.search);
console.log(searchParams);
const token_ = searchParams.get("token");
console.log(token_);
const header = {
  token: token_ ? `Bearer ${token_}` : `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI5NzcyN2IxYi0wMDBiLTQwYjgtODM2NC05OWNkYTc4OTA3MjYiLCJ1c2VyX2lkIjoxMjYxMjAsImlhdCI6MTc2MzgwMzQ1M30.Epamz_fN2yydqtby8fSck1VpR2OvVoeiM4dJVJdxqbg`,
  "x-api-key":  "9LOIq8++9bbe9SQMOteOqa5OADUNRrUM2yjJUlIDCki7JFbFzz8xIifFRIhiV4dRoufZ1QFYoWeMmkmoEH0jIIe70+7y2wdWnrO07+f3/uiDyjXICeJ+bMTV4Q1OoUACVIDgEd6JlIYjpmCsPc/hAR0DQH6Xlh9z3CDJBqB3QG7yeY5T8uu7Q0tT7OGqK/B7rwEvLLnzmWHTH1iRDITULIJVBqHh5lDczCr1NFhNsMF/iB/upMI1kylV9hmUJH2nrEu7TyOSnL6QnAHU8ZtkWkcwFRHCzraBuMcxOdI6XPT7xfzWHXk6KA3U1mSYJJLRjI07hQkDzwIELkgV4qOnf7fE6l8w+Laz9ts9cGV/EeT3DTNw2SlTl+wxAcAQkxLBUvURjN6jaz016C/SSTncKqN7ct8VIuPBztx+81yKwPRuS/BfgBWuhO1yDVdC6jMW+QWH3z8Hip2ICN6UPL7nCh1K0QdCPqLKQ+d/W+oga+oZuseAHnYZjdKAsr+3nHH1hYhlClpLEL8EcFLW0KO1lseJSdTcR7R6/AYc7800r2EHnDJ0hWm6ZIppPB/rbX4Cr8TCBr2ww3zJfb8UBSoAZ04Yp3/D"
};

(async () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      axios
        .post("/amiAPI/bot/saveUserLoc", {
          loc: `${position.coords.latitude},${position.coords.longitude}`,
          userToken,

        }, { headers: header })
        .then((res) => { });
    });
  }
})();

export function Api(apiBody: any, lang: any, inputType: any, callback: any) {
  const url = `/amiAPI/bot/sendQuery/${lang}`;

  const body = {
    query: apiBody,
    userToken: token,
    inputType: inputType,
    source: "bot",
  };


  axios
    .post(url, body, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        if (response.data?.responseError?.errorCode === 401) {
          callback({
            answer: {
              response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
            }
          });
          return;
        }
        callback(response.data);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (
        error.response?.status === 401 || 
        error.response?.data?.statusCode === 401 || 
        error.response?.data?.responseError?.errorCode === 401
      ) {
        callback({
          answer: {
            response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
          }
        });
      }
    });
}

export function FileUpload(apiBody: any, lang: any, callback: any) {
  const url = `/amiAPI/bot/sendQuery/${lang}`;
  const body = new FormData();
  body.append("userToken", token);
  body.append("file", apiBody);
  body.append("source", "bot");
  axios
    .post(url, body, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        if (response.data?.responseError?.errorCode === 401) {
          callback({
            answer: {
              response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
            }
          });
          return;
        }
        callback(response.data);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (
        error.response?.status === 401 || 
        error.response?.data?.statusCode === 401 || 
        error.response?.data?.responseError?.errorCode === 401
      ) {
        callback({
          answer: {
            response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
          }
        });
      }
    });
}

export function RecommendSchemesApi(lang: any, callback: any) {
  const url = `/amiAPI/bot/recommendSchemes/${lang}`;

  const body = {
    userToken: token,
    source: "bot",
  };

  axios
    .post(url, body, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        if (response.data?.responseError?.errorCode === 401) {
          callback({
            answer: {
              response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
            }
          });
          return;
        }
        callback(response.data);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (
        error.response?.status === 401 || 
        error.response?.data?.statusCode === 401 || 
        error.response?.data?.responseError?.errorCode === 401
      ) {
        callback({
          answer: {
            response: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en
          }
        });
      }
    });
}

export function FeedbackApi(
  answerId: any,
  feedback: boolean,
  feedbackTxt: any
  // callback: any
) {
  const url = `/amiAPI/bot/feedback`;
  const body = {
    answerId: answerId,
    feedback: {
      like: feedback,
      comment: feedbackTxt,
    },
  };

  axios
    .post(url, body, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        // callback(response.data);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

export function AudioToTextApi(
  audioBase64: string,
  lang: string,
  callback: (response: any) => void
) {
  const url = `/amiAPI/bot/audioToText`;
  const body = {
    query: audioBase64,
    isAudio: true,
    language: lang,
  };

  console.log("🎧 [AudioToTextApi] URL:", url);
  console.log("🎧 [AudioToTextApi] Body.isAudio:", body.isAudio, "language:", body.language);
  console.log("🎧 [AudioToTextApi] audioBase64 length:", audioBase64?.length || 0);

  axios
    .post(url, body, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        if (response.data?.responseError?.errorCode === 401) {
          callback({ error: "Unauthorized", text: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en });
          return;
        }
        const data: any = response.data;
        console.log("🎧 [AudioToTextApi] Raw response.data:", data);
        // Normalise different backend response shapes to always expose "text"
        const text =
          data.text ||
          data.transcription ||
          data.Transcription ||
          data.transcript ||
          "";

        console.log("🎧 [AudioToTextApi] Normalised text field:", text);
        callback({ ...data, text });
      }
    })
    .catch((error) => {
      console.error("Error in AudioToText:", error);
      if (
        error.response?.status === 401 || 
        error.response?.data?.statusCode === 401 || 
        error.response?.data?.responseError?.errorCode === 401
      ) {
        callback({ error: "Unauthorized", text: UnauthorizedError[lang as keyof typeof UnauthorizedError] || UnauthorizedError.en });
        return;
      }
      callback({ error: error.message, text: "" });
    });
}

export function fetchAppModules(callback: any) {
  const url = `/amiAPI/bot/fetchButtons`;

  axios
    .get(url, { headers: header })
    .then((response) => {
      if (response && response.data !== undefined) {
        callback(response.data);
      }
    })
    .catch((error) => {
      console.error("Error fetching app modules:", error);
    });
}

// const useRecommendSchemesApi = (lang) => {
//   const [recommendSchemesdata, setRecommendSchemesData] = useState(null);
//   const [recommendSchemeserror, setRecommendSchemesError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       setRecommendSchemesError(null);

//       try {
//         const url = `/amiAPI/bot/recommendSchemes/${lang}`;
//         const body = {
//           userToken: token,
//           source: "bot",
//         };

//         const response = await axios.post(url, body, { headers: header }); // Make sure 'header' is defined

//         if (response && response.data !== undefined) {
//           setRecommendSchemesData(response.data);
//         }
//       } catch (error) {
//         setRecommendSchemesData(error);
//       }
//     };

//     fetchData();
//   }, [lang]);

//   return { recommendSchemesdata, recommendSchemeserror };
// };

// const useSendQueryApi = () => {
//   const [sendQuerydata, setSendQueryData] = useState(null);
//   const [sendQueryError, setSendQueryError] = useState(null);

//   const fetchData = async (apiBody, lang, inputType) => {
//     setSendQueryError(null);

//     try {
//       const url = `/amiAPI/bot/sendQuery/${lang}`;
//       const body = {
//         query: apiBody,
//         userToken: token, // Replace 'token' with your actual token
//         inputType: inputType,
//         source: "bot",
//       };
//       console.log(body);
//       const response = await axios.post(url, body, { headers: header }); // Make sure 'header' is defined

//       if (response && response.data !== undefined) {
//         console.log(response.data);
//         setSendQueryData(response.data);
//       }
//     } catch (error) {
//       setSendQueryData(error);
//     }
//   };

//   return { sendQuerydata, sendQueryError, fetchData };
// };

// export  { useRecommendSchemesApi, useSendQueryApi };

window.addEventListener("beforeunload", () => {
  sessionStorage.clear();
});
